import React from 'react';

import { TextField } from '@material-ui/core';
import useStyles from './styles';

const TextAnswer = ({ editableAnswer, setEditableAnswer }) => {
  const classes = useStyles();

  const handleOnChange = (e) => {
    setEditableAnswer(e.target.value);
  };

  return (
    <div className={classes.content}>
      <TextField
        value={editableAnswer}
        multiline minRows={4}
        variant="outlined"
        className={classes.textField}
        onChange={(e) => handleOnChange(e)}
      >
      </TextField>
    </div>
  );
};

export default TextAnswer;
